import Selectable from './selectable';

export default Selectable.extend( {
	tagName: 'button',

	events: {
		'click': 'toggle',
	},

	render: function() {
		this.$el.attr( 'type', 'button' ).text( this.model.get( 'label' ) );

		return this;
	},
} );
